import React from "react"
import clsx from "clsx"
import DataTable from "../../DataTable/DataTable"

export default class PropertyDetailsPresenterHistory extends React.Component {
	
	constructor(props) {
		super(props)
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'history',
			'tab-pane': true
    });


		return (
			<div className={tabClasses} id="history">
				<div className="row">
					<div className="col-md-12">
						<DataTable
							endpoint={this.props.property_details_revision_history_path}
							no_data_text={I18n.t('none')}
							currency_unit={I18n.t('number.currency.format.unit')}
							delimiter={I18n.t('number.currency.format.delimiter')}
							separator={I18n.t('number.currency.format.separator')}
							date_format={this.props.date_format}
							time_format={this.props.time_format}
							model_name={"Property"}
						/>
					</div>
				</div>
			</div>
		)
	}
	
}
